import { z } from 'zod';
import moment from 'moment';

import { ProjectNeedsSchema } from './project-needs';

function checkDateRange(
  context: z.RefinementCtx,
  errorPath: string,
  startDate: string,
  endDate: string
) {
  if (!moment(endDate).isAfter(moment(startDate), 'day')) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Must be after start date',
      path: [errorPath],
    });
  }

  if (
    moment.duration(moment(endDate).diff(moment(startDate))).as('days') < 30
  ) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Minimum engagement duration is 30 days',
      path: [errorPath],
    });
  }
}

export const ProjectNeedsWithLegalSkillsSchema = ProjectNeedsSchema.extend({
  legalSkillsAnswers: z.array(z.array(z.string()).nullish()).nullish(),
}).superRefine((schema, ctx) => {
  checkDateRange(ctx, 'endDate', schema.startDate, schema.endDate);
});

export type ProjectNeedsWithLegalSkills = z.infer<
  typeof ProjectNeedsWithLegalSkillsSchema
>;
